import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const CaseDetailPage = lazy(() => import('./detail-page').then((m) => ({ default: m.CaseDetailPage })));
const CaseFormPage = lazy(() => import('./form-page').then((m) => ({ default: m.CaseFormPage })));
const CaseListPage = lazy(() => import('./list-page').then((m) => ({ default: m.CaseListPage })));

export const caseRoutes: RouteObject[] = [
  {
    path: 'cases',
    handle: { crumb: 'Cases' },
    children: [
      { index: true, element: <CaseListPage /> },
      { path: 'new', element: <CaseFormPage />, handle: { crumb: 'New case' } },
      { path: ':id', element: <CaseDetailPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'Case' } },
    ],
  },
];
